export default "__VITE_ASSET__BousfXkQ__"